export const NextItemArrow = ({ height }: { height: number }) => {
  return (
    <svg
      width='32'
      height={height}
      viewBox={`0 0 32 ${height}`}
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M32 0.0158234C31.668 0.00530243 31.3346 0 31 0C13.8792 0 0 13.8792 0 31C0 48.1208 13.8792 62 31 62C31.3346 62 31.668 61.9947 32 61.9842L32 0.0158234Z'
        fill='#CDCDCD'
      />
      <path
        d='M13.6011 41.3415C13.2965 41.0368 13.1253 40.6235 13.1253 40.1926C13.1253 39.7617 13.2965 39.3485 13.6011 39.0437L21.6449 31L13.6011 22.9562C13.3051 22.6498 13.1413 22.2393 13.145 21.8132C13.1487 21.3871 13.3196 20.9796 13.6209 20.6783C13.9222 20.377 14.3298 20.2061 14.7558 20.2024C15.1819 20.1987 15.5924 20.3625 15.8989 20.6585L25.0915 29.8511C25.3961 30.1558 25.5673 30.5691 25.5673 31C25.5673 31.4309 25.3961 31.8441 25.0915 32.1489L15.8989 41.3415C15.5941 41.6461 15.1809 41.8173 14.75 41.8173C14.3191 41.8173 13.9058 41.6461 13.6011 41.3415Z'
        fill={'#FAFAFA'}
      />
    </svg>
  )
}
